export const SOURCE_TRIM_ACCESS_TOKEN_KEY = 'source_trim_access_token';
export const SOURCE_TRIM_ACCESS_EXPIRES_AT_KEY = 'source_trim_access_expires_at';
export const SOURCE_TRIM_ACCESS_INVALID_EVENT = 'source_trim_access_invalid';

export function isInternalSourceTrimUser(authInfo) {
    return authInfo?.isAuth === true && ['1', '2', '3', '4'].includes(String(authInfo?.user?.type_user ?? ''));
}

export function getSourceTrimAccess() {
    if (typeof window === 'undefined') {
        return null;
    }

    const token = localStorage.getItem(SOURCE_TRIM_ACCESS_TOKEN_KEY);
    const expiresAt = localStorage.getItem(SOURCE_TRIM_ACCESS_EXPIRES_AT_KEY);
    const expiresAtMs = Date.parse(expiresAt || '');

    if (!token || !expiresAt || Number.isNaN(expiresAtMs) || expiresAtMs <= Date.now()) {
        clearSourceTrimAccess();
        return null;
    }

    return { token, expiresAt };
}

export function storeSourceTrimAccess(token, expiresAt) {
    localStorage.setItem(SOURCE_TRIM_ACCESS_TOKEN_KEY, token);
    localStorage.setItem(SOURCE_TRIM_ACCESS_EXPIRES_AT_KEY, expiresAt);
}

export function clearSourceTrimAccess() {
    localStorage.removeItem(SOURCE_TRIM_ACCESS_TOKEN_KEY);
    localStorage.removeItem(SOURCE_TRIM_ACCESS_EXPIRES_AT_KEY);
}

export function notifySourceTrimAccessInvalid() {
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event(SOURCE_TRIM_ACCESS_INVALID_EVENT));
    }
}
